import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import RedirectToNow from './RedirectToNow';
import LinkToDate from './LinkToDate';
import Divider from '../Divider';

class DateSelector extends React.Component {
    constructor(props) {
        super(props);

        const { start, end } = props;
        this.state = {
            start,
            end,
            disableReport: true,
        };
    }

    componentDidMount() {
        this.getReport();
    }

    componentDidUpdate(prevProps) {
        const { start, end, organizationId } = this.props;
        if (
            prevProps.start !== start ||
            prevProps.end !== end ||
            prevProps.organizationId !== organizationId
        ) {
            this.setState({
                start: start,
                end: end,
                disableReport: true,
            });
            this.getReport();
        }
    }

    onStartChange = e => {
        const { start: oldStart, end: oldEnd } = this.props;
        const start = e.target.value;
        if (!start) {
            return;
        }
        const { end } = this.state;
        const disableReport = start === oldStart && end === oldEnd;
        this.setState({ start, disableReport });
    };

    onEndChange = e => {
        const { start: oldStart, end: oldEnd } = this.props;
        const end = e.target.value;
        if (!end) {
            return;
        }
        const { start } = this.state;
        const disableReport = start === oldStart && end === oldEnd;
        this.setState({ end, disableReport });
    };

    getReport() {
        const { start, end, organizationId, generateReport } = this.props;

        if (start && end) {
            generateReport({ start, end, organizationId });
        }
    }

    render() {
        const {
            organizationId,
            start: reportStart,
            end: reportEnd,
            classes,
        } = this.props;
        if (!reportStart || !reportEnd) {
            return <RedirectToNow organizationId={organizationId} />;
        }
        const { start, end, disableReport } = this.state;
        if (!start || !end) {
            return null;
        }
        return (
            <React.Fragment>
                <div className={classes.dateSelectorWrapper}>
                    <div className={classes.holder}>
                        <Typography className={classes.label} variant="caption">
                            From
                        </Typography>
                        <TextField
                            className={classes.component}
                            name="start"
                            type="date"
                            onChange={this.onStartChange}
                            value={start}
                            required
                        />
                        <Typography className={classes.label} variant="caption">
                            To
                        </Typography>
                        <TextField
                            className={classes.component}
                            name="end"
                            type="date"
                            onChange={this.onEndChange}
                            value={end}
                            required
                        />
                        <LinkToDate
                            className={classes.component}
                            start={start}
                            end={end}
                            organizationId={organizationId}
                            disabled={disableReport}
                        />
                    </div>
                </div>
                <Divider horizontal />
            </React.Fragment>
        );
    }
}

DateSelector.propTypes = {
    start: PropTypes.string,
    end: PropTypes.string,
    organizationId: PropTypes.number.isRequired,
    generateReport: PropTypes.func.isRequired,
};

DateSelector.defaultProps = {
    start: undefined,
    end: undefined,
};

const style = ({ spacing }) => ({
    dateSelectorWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: spacing.maxActionComponentHeight,
    },
    holder: {
        width: '100%',
        maxWidth: spacing.maxWidth,
        display: 'flex',
        alignItems: 'center',
    },
    label: {
        marginRight: spacing.unit,
    },
    component: {
        marginRight: spacing.unit * 3,
    },
});

export default injectSheet(style)(DateSelector);



// WEBPACK FOOTER //
// ./src/components/report/DateSelector.js